import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../services/queryClient";
import { getToken } from "../../utils/getToken";

export const useDeleteBranchMutation = (data: any) => {
  const payload = { branches: data };
  const token = getToken();

  return useMutation({
    mutationFn: () =>
      axiosInstance
        .delete("/branches/", {
          data: payload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["getBranches"] });
      message.success(data?.message);
    },
    onError: (error: any) => {
      message.error(
        error?.response?.data?.message || "Failed to delete branches"
      );
    },
  });
};
